<template>
  <div ref="customPopup" class="custom-popup">
    <VanPopup
      ref="popupRef"
      v-model:show="isShowPopup"
      round
      close-on-popstate
      safe-area-inset-bottom
      position="bottom"
      teleport="body"
      :z-index="2000"
      :lazy-render="true"
      class="custom-popup-panel"
      :style="popupStyle"
      @open="emitModel(true)"
      @close="emitModel(false)"
    >
      <div
        ref="customPopupTop"
        class="custom-popup-top rounded-t-2xl"
        @click.stop
      >
        <div
          v-if="myProps.isShowConfirm"
          class="custom-popup-top-confirm"
          @click.stop="eventConfirm"
        >
          <span>{{ myProps.confirmText }}</span>
        </div>
        <div class="custom-popup-top-title">{{ myProps.title }}</div>
        <div
          class="custom-popup-top-cancel"
          :class="{
            'ml-auto': !myProps.isShowConfirm,
          }"
          @click.stop="eventCancel"
        >
          <span v-if="myProps.isShowConfirm">{{ myProps.cancelText }}</span>
          <van-icon v-else name="cross" />
        </div>
      </div>
      <div class="custom-popup-wrap">
        <slot />
      </div>
    </VanPopup>
  </div>
</template>

<script setup lang="ts">
  const myProps = withDefaults(
    defineProps<{
      modelValue: boolean
      title?: string
      isShowConfirm?: boolean
      confirmText?: string
      cancelText?: string
      height?: string
      slotKey?: string
    }>(),
    {
      title: '',
      isShowConfirm: true,
      confirmText: '确定',
      cancelText: '取消',
      height: '80%',
      slotKey: '',
    },
  )

  const isShowPopup = ref(false)
  let isConfirm = false

  const popupStyle = computed(() => ({
    height: myProps.height,
    display: 'flex',
    flexDirection: 'column' as const,
    overflow: 'hidden',
  }))

  const emit = defineEmits<{
    'update:model-value': [value: any]
    confirm: []
    cancel: []
    close: [isConfirm: boolean]
    open: []
  }>()

  provide('isShowPopup', isShowPopup)
  provide(
    'slotKey',
    computed(() => myProps.slotKey),
  )

  function emitModel(status: boolean) {
    emit('update:model-value', status)
    if (!status) {
      emit('close', isConfirm)
      isConfirm = false
    } else {
      emit('open')
    }
  }

  function eventConfirm() {
    emit('confirm')
    isConfirm = true
    isShowPopup.value = false
  }
  function eventCancel() {
    emit('cancel')
    isShowPopup.value = false
  }

  watch(
    () => myProps.modelValue,
    (nv) => {
      isShowPopup.value = nv
    },
  )
</script>
<style scoped lang="scss">
  $active-color: #ff6a00;
  $default-color: #444b61;

  .custom-popup-top {
    position: relative;
    z-index: 10;
    display: flex;
    flex-shrink: 0;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;
    padding: 16px;
    background: white;

    .custom-popup-top-title {
      position: absolute;
      right: 0;
      left: 0;
      z-index: 2;
      font-size: 13px;
      font-weight: 400;
      color: #929ba5;
      text-align: center;
      pointer-events: none;
    }

    .custom-popup-top-cancel,
    .custom-popup-top-confirm {
      position: relative;
      z-index: 3;
      font-size: 15px;
      font-weight: 400;
      color: $default-color;
    }

    .custom-popup-top-confirm {
      color: $active-color;
    }
  }

  .custom-popup-wrap {
    /* height:0 + flex:1：强制占满剩余高度，否则内容区常为 0 只剩白屏 */
    flex: 1 1 auto;
    height: 0;
    min-height: 0;
    overflow: hidden;

    > :deep(*) {
      height: 100%;
    }
  }
</style>
